import styled, { keyframes } from "styled-components";

const fadeInUp = keyframes`
  0% {
    opacity: 0;
    transform: translateY(30px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;


export const FiltersWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  background: #f9f9fb;
  border: 1px solid #e0e0e0;
  border-radius: 16px;
  padding: 1.5rem 2rem;
  margin: 80px auto 2rem;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
  max-width: 1200px;

`;
export const LabelsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
  label {
    display: flex;
    flex-direction: column;
    font-size: 0.95rem;
    color: #444;

    input, select {
      margin-top: 0.3rem;
      padding: 0.5rem 1rem;
      border-radius: 10px;
      border: 1px solid #ccc;
      font-size: 1rem;
      background: white;
      outline: none;
      transition: border 0.2s;

      &:focus {
        border: 1px solid #7b4ef7;
      }
    }
  }
`

// Сетка карточек студентов с анимацией fade-in-up
export const StudentsList = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 2rem;
  margin-top: 2rem;
`;

export const StudentCard = styled.div`
  background: #fff;
  border: 1px solid #e5e5e5;
  border-radius: 16px;
  padding: 1.5rem;
  transition: box-shadow 0.3s ease;
  cursor: pointer;

  p {
    margin: 0.5rem 0;
    color: #333;
    font-size: 0.95rem;
  }

  &:hover {
    box-shadow: 0 8px 20px rgba(0,0,0,0.08);
  }
`;



export const ButtonsWrapper = styled.div`
  display: flex;
  gap: 1rem;
  align-items: flex-end;

  button {
    padding: 0.6rem 1.5rem;
    border-radius: 10px;
    border: none;
    font-size: 1rem;
    font-weight: 600;
    background-color: #7b4ef7;
    color: white;
    cursor: pointer;
    transition: background 0.2s ease;

    &:hover {
      background-color: #6538dc;
    }

    &:disabled {
      background: #ccc;
      cursor: not-allowed;
    }
  }
`;
